import { store as auth } from "@/modulos/auth";
import { store as home } from "@/modulos/home";
import { store as trabalhador } from "@/modulos/trabalhador";
import { store as depedentes } from "@/modulos/depedentes";
import { store as tomador } from "@/modulos/tomador";
import { store as taxa } from "@/modulos/taxa";
import { store as tabelapreco } from "@/modulos/tabelapreco";
import { store as tabelaprecorublica } from "@/modulos/tabelaprecorublica";
import { store as comissionado } from "@/modulos/comissionador";
import { store as boletinstabela } from "@/modulos/boletins/tabela";
import { store as boletinscartaoponto } from "@/modulos/boletins/cartaoponto";
import { store as boletinstabelatrabalhadores } from "@/modulos/boletins/tabela/trabalhadores";
import { store as boletinscartaopontotrabalhadores } from "@/modulos/boletins/cartaoponto/trabalhadores";
import { store as inss } from "@/modulos/inss";
import { store as irrf } from "@/modulos/irrf";
import { store as vale } from "@/modulos/vale";
import { store as folhar } from "@/modulos/folhar";
import { store as fatura } from "@/modulos/fatura";
import { store as rescisaocontrator } from "@/modulos/rescisaocontrator";
import { store as backup } from "@/modulos/backup";
import { store as acidentetrabalhor } from "@/modulos/trabalhador/sst/acidentetrabalhor";
import { store as saudetrabalhor } from "@/modulos/trabalhador/sst/saudetrabalhador";
import { store as ambientetrabalhor } from "@/modulos/trabalhador/sst/ambientetrabalhor";
import { store as avuso } from "@/modulos/avuso";
import { store as cartademissao } from "@/modulos/cartademissao";
import { store as dstavulso } from "@/modulos/dstavulso";
import { store as ferias } from "@/modulos/ferias";
import { store as decimo } from "@/modulos/decimo";
import { store as rubrica } from "@/modulos/rubrica";
import { store as aplicativo } from "@/modulos/app";
import { store as folharaplicativo } from "@/modulos/folhar/page/aplicativo";
import { store as categoria } from "@/modulos/categoria";
import { store as cbo } from "@/modulos/cbo";
import { store as cargohoraria } from "@/modulos/cargohoraria";
import { store as trabalhadorlotacao } from "@/modulos/trabalhador/lotacao";
import { store as trabalhadorafastamento } from "@/modulos/trabalhador/afastamento";
import { store as trabalhadorcontrato } from "@/modulos/trabalhador/contrato";
import { store as trabalhadordesligamento } from "@/modulos/trabalhador/desligamento";
import { store as trabalhadorcessao } from "@/modulos/trabalhador/cessao";
import { store as trabalhadorreintegracao } from "@/modulos/trabalhador/reintegracao";
import { store as tabelaprecorublicaevento } from "@/modulos/tabelaprecorublica/esocial";
import { store as folharevento } from "@/modulos/folhar/page/esocial";
import { store as folharevento1270 } from "@/modulos/folhar/page/esocial/evento1270";
import { store as desligamentotabelapreco } from "@/modulos/trabalhador/desligamento/tabelapreco";
import { store as trabalhadorvaletransporte } from "@/modulos/trabalhador/valetransporte";
import { store as trabalhadorvalealimentacao } from "@/modulos/trabalhador/valealimentacao";
import { store as folharverpagamento } from "@/modulos/folhar/page/verpagamento";
import { store as folharverpagamentotomador } from "@/modulos/folhar/page/verpagamento/tomador";
import { store as folhartaxas } from "@/modulos/configuracao/folha/taxas";
import { store as folharauto } from "@/modulos/configuracao/folha/auto";
import { store as calendariodiasuteis } from "@/modulos/configuracao/ferias/calendariodiasuteis";
import { store as feriado } from "@/modulos/configuracao/ferias/feriado";
import { store as trabalhadorauto } from "@/modulos/trabalhador/configuracao/geral";
import { store as certificado } from "@/modulos/certificado";
import { store as configuracaotrabalhador2200 } from "@/modulos/configuracao/esocial/trabalhador/evento2200";
import { store as empresa } from "@/modulos/empresa";
import { store as trabalhadorbackup } from "@/modulos/configuracao/backup/trabalhador";
import { store as tomadorbackup } from "@/modulos/configuracao/backup/tomador";
import { store as tabelaprecobackup } from "@/modulos/configuracao/backup/tabelapreco";
import { store as boletimbackup } from "@/modulos/configuracao/backup/boletim";
import { store as epi } from "@/modulos/trabalhador/epi";
import { store as trabalhadoradvertencia } from "@/modulos/trabalhador/advertencia";
import { store as trabalhadornotas } from "@/modulos/trabalhador/notas";
import {store as usuario} from '@/modulos/usuarios'
import {store as aviso} from '@/modulos/componente/dashboard';
import {store as alerta} from '@/modulos/aviso';
export default{
    auth,
    home,
    trabalhador,
    depedentes,
    tomador,
    taxa,
    tabelapreco,
    tabelaprecorublica,
    comissionado,
    boletinstabela,
    boletinstabelatrabalhadores,
    inss,
    irrf,
    vale,
    folhar,
    fatura,
    boletinscartaoponto,
    boletinscartaopontotrabalhadores,
    rescisaocontrator,
    backup,
    acidentetrabalhor,
    avuso,
    cartademissao,
    dstavulso,
    ferias,
    decimo,
    rubrica,
    aplicativo,
    folharaplicativo,
    categoria,
    cbo,
    cargohoraria,
    trabalhadorlotacao,
    trabalhadorafastamento,
    trabalhadorcontrato,
    trabalhadordesligamento,
    trabalhadorcessao,
    trabalhadorreintegracao,
    tabelaprecorublicaevento,
    folharevento,
    desligamentotabelapreco,
    trabalhadorvaletransporte,
    trabalhadorvalealimentacao,
    folharverpagamento,
    folhartaxas,
    folharauto,
    calendariodiasuteis,
    feriado,
    trabalhadorauto,
    certificado,
    configuracaotrabalhador2200,
    empresa,
    trabalhadorbackup,
    epi,
    saudetrabalhor,
    ambientetrabalhor,
    tomadorbackup,
    tabelaprecobackup,
    boletimbackup,
    folharverpagamentotomador,
    folharevento1270,
    trabalhadoradvertencia,
    trabalhadornotas,
    usuario,
    aviso,
    alerta
}